import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import QRCodeForm from './QRCodeForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';
import QRCodeStyling from 'qr-code-styling';
import url from 'socket.io-client/lib/url';
import defaultBrandedImage from 'appSrc/assets/img/v2.svg';
import { tdcDomainMatch } from 'appSrc/utils/random';

class EditQRCodeModal extends PureComponent {
    
    constructor(props) {
        super(props);
        this.myRef = React.createRef();

        this.state = {
            deleteConfirm: false,
            fetching: false,
            qrCodeData: null,
        };

        this.qrCodeData = new QRCodeStyling({
            width: 300,
            height: 300,
            dotsOptions: {
                color: '#000',
                type: 'square',
            },
            imageOptions: {
                crossOrigin: 'anonymous',
                margin: 5,
                imageSize: 0.5,
            },
        });
    }

    componentDidMount = () => {
        this.qrCodeData.update({
            data: `${tdcDomainMatch()}/qr/dynamic/${this.props.qrCode.id}`,
            image: this.props.qrCode.branded_image ? `${this.props.qrCode.branded_image}?${Date.now()}` : defaultBrandedImage,
        });
        this.qrCodeData.append(this.myRef.current);
    }

    submitHandler = ( qrCode ) => {

        this.setState( { fetching: true } );        
        this.props.updateQRCode( qrCode )
        .then( ( newQRCode ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newQRCode );
        } );
    }

    toggleDeleteConfirmation = ( state ) => {
        return () => {
            this.setState( { deleteConfirm: state } );
        };
    }

    downloadQRCode = () => {
        this.props.downloadQRCode(this.props.qrCode);
    }

    deleteQRCode = () => {
        this.setState( { fetching: true } );
        this.props.deleteQRCode( this.props.qrCode.id )
        .then( () => {
            this.setState( { fetching: false, deleteConfirm: false } );
            this.props.onSubmit && this.props.onSubmit( null );
        } );
    }

    render() {
        const { qrCode } = this.props;
        var initialValues = { ...qrCode, nfcURL: `${tdcDomainMatch()}/qr/dynamic/${this.props.qrCode.id}` };

        return (
            <DLModal title='Edit QR Code'
            closeHandler={ this.props.closeModal }>
                <div>
                    <QRCodeForm 
                    onSubmit={ this.submitHandler }
                    initialValues={ initialValues } />
                    { this.renderDownloadSection() }
                    { this.renderDeleteSection() }
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

    renderDownloadSection = () => {
        return (
            <div className={style.qr}>
                <div className={style.deleteLink}>
                    <span onClick={ this.downloadQRCode }>
                        DOWNLOAD THIS QR CODE
                    </span>
                </div>
                <br />
                <div ref={this.myRef} />
            </div>
        );
    }

    renderDeleteSection = () => {

        if( this.state.deleteConfirm ) {
            return (
                <div className={style.deleteLink}>
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS QR CODE?</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.deleteQRCode }>
                            DELETE QR CODE
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            CANCEL
                        </span>
                    </p>
                </div>
            );
        }

        return (
            <div className={style.deleteLink}>
                <span onClick={ this.toggleDeleteConfirmation( true ) }>
                    DELETE THIS QR CODE
                </span>
            </div>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        updateQRCode: ( data ) => {
            return dAPI.patch( `/admin/qr_codes/${ data.id }`, data );
        },
        deleteQRCode: ( id ) => {
            return dAPI.delete( `/admin/qr_codes/${ id }` );
        },
    };
};

export default connect( null, mapDispatchToProps )( EditQRCodeModal );
